import {AxiosResponse} from 'axios'
import $api from "../../../http";
import {SearchResponse} from "../../../models/SearchResponse";

export function search(query: string): Promise<AxiosResponse<SearchResponse[]>> {
    return $api.get<SearchResponse[]>(`search?query=${query}`)
}